import { Tabs } from 'antd'
import React from 'react'
import TabPane from 'antd/lib/tabs/TabPane';
import { MassImport } from './MassImport';
import { ImportCompetitors } from './ImportCompetitors';

export function ScnGeneral() {
    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="Import de masse" key="1">
                <MassImport />
            </TabPane>
            <TabPane tab="Fournisseurs concurrents" key="2">
                <ImportCompetitors />
            </TabPane>
        </Tabs>
    )
}